<template>
  <section class="app flex-container">
    <loading-overlay :show="$store.getters['user/loading']" />
    <notifications/>
    <header class="main">
      <router-view name="header"></router-view>
    </header>

    <main class="flex-full-height scroll-hidden">
      <router-view name="main"></router-view>
    </main>
    <menu-right></menu-right>

  </section>
</template>

<script>
import 'vue-awesome/icons/circle'
import 'vue-awesome/icons/sun'
import 'vue-awesome/icons/chart-line'
import 'vue-awesome/icons/table'
import 'vue-awesome/icons/eye'
import 'vue-awesome/icons/bars'
import 'vue-awesome/icons/eye-slash'
import 'vue-awesome/icons/angle-down'

import Vue from 'vue'
import store from './store'
import router from './router'
import LoadingOverlay from './components/LoadingOverlay'
import MenuRight from './components/MenuRight.vue'
import TasksPlugin from './plugin/tasks'

import {loadChainedScripts} from './util/misc'

Vue.prototype.$store = store
Vue.prototype.$bus = new Vue

Vue.use(TasksPlugin)

export default {
  name: 'App',
  components: {LoadingOverlay, MenuRight},
  mounted () {
    // Potree point-cloud disabled for local standup (2026-05-29): the lib/potree assets were
    // removed, so these chained scripts 404 (returning index.html -> "Unexpected token '<'").
    // Skipped to silence the console errors; re-enable together with the lib/potree build.
    // let me = this
    // loadChainedScripts([
    //   '/three.min.js',
    //   '/BinaryHeap.js',
    //   '/proj4.js',
    //   '/tween.min.js',
    //   '/potree.js'], () => {
    //   me.$store.commit('map/potreeLoaded', true)
    // })
  }
}
</script>

<style lang="scss">
  @import 'intro.js/introjs.css';
</style>



// WEBPACK FOOTER //
// src/App.vue